import VHVideoModule from "./SDK/index2.1.0";
import VhallInterface from "./VhallInterface";
import { loadMsgScript, getType } from './common/Utils';
import axios from "axios";
import { EVENT, KV } from "./common/Constant";
import API from "./message/Api";
import Store from "./common/Store"
window.VhallPlayer = new class VhallPlayer {
  constructor() {
    for (let i in EVENT) {
      this[i] = EVENT[i]
    }
  }

  /**
   * 创建实例
   * @param {object} opt 创建实例所需配置
   * @param {funciton} success 成功回调
   * @param {function} failure 失败回调
   */
  async createInstance(opt, success, failure) {
    const { appId, accountId, token, type } = opt;
    const isLoadScript = await loadMsgScript();
    this.store = new Store();
    this.store.setKV(KV.APP_ID, appId)
    this.store.setKV(KV.THIRD_PARTY_USER_ID, accountId)
    this.store.setKV(KV.ACCESS_TOKEN, token)
    this.store.setKV(KV.PACKAGE_CHECK, 'peter')
    this.store.setKV(KV.CLIENT, 'pc_browser')
    this.api = new API(this.store);

    if (!accountId) {
      failure && failure({ code: '611001', message: "无效的参数", data: {} });
      return;
    }
    const vhallplayer = new VHVideoModule();

    let initData = null;
    let playerData = null;
    try {
      initData = await this.api.init();
      switch (type) {
        case "live":
          if (!opt.hasOwnProperty('liveOption') || !opt.liveOption.hasOwnProperty('type') || !opt.liveOption.hasOwnProperty('roomId') || (opt.liveOption.type !== "flv" && opt.liveOption.type !== "hls")) {
            failure && failure({ code: '611001', message: "无效的参数", data: {} });
            return;
          }
          playerData = await this.api.initLive(opt.liveOption.roomId);
          break;
        case "vod":
          if (!opt.hasOwnProperty('vodOption') || !opt.vodOption.hasOwnProperty('recordId')) {
            failure && failure({ code: '611001', message: "无效的参数", data: {} });
            return;
          }
          playerData = await this.api.initVod(opt.vodOption.recordId);
          break;
        default:
          failure && failure({ code: '611001', message: "无效的参数", data: {} });
          break;
      }
    } catch (err) {
      console.error(err);
      switch (err.msg) {
        case "房间查询为空":
          failure && failure({ code: '611009', message: 'roomId不存在', data: {} });
          break;
        case "AccessToken格式不正确":
          failure && failure({ code: '611010', message: 'token不存在', data: {} });
          break;
        case "应用查询为空":
          failure && failure({ code: '611008', message: 'appId不存在', data: {} });
          break;
        default:
          failure && failure({ code: '611000', message: '初始化播放器失败', data: {} })
          break;
      }
      return;
    }

    // 日志上报配置
    const reportConfig = {
      url: initData.log_server,
      webinar_id: type === "live" ? opt.liveOption.roomId.trim() : opt.vodOption.recordId.trim(),
      uid: playerData.log_info.uid,
      session_id: playerData.log_info.session_id,
      vid: playerData.log_info.third_party_user_id,
      vfid: playerData.log_info.account_id,
      ndi: '',    // 移动端上报  paas为空
      guid: '',   // saas平台上报  paas为空
      vtype: '',  // saas平台上报  paas为空
      topic: '',  // saas平台上报  paas为空
      app_id: appId,
      biz_role: opt.hasOwnProperty("otherOption") ? opt.otherOption.biz_role : '',  // 教育版用户角色  paas为空
      flow_type: 2,  // 流量类型  默认为2
      biz_id: opt.hasOwnProperty("otherOption") ? opt.otherOption.biz_id : '',   // 教育版业务ID  paas 为空
      biz_des01: opt.hasOwnProperty("otherOption") ? opt.otherOption.biz_des01 : '',  // 教育版业务属性 paas为空
      bu: 1,          // 业务类型 pass 为1
      enable: true, //是否启用日志上报功能
      biz_des02: opt.hasOwnProperty("otherOption") ? opt.otherOption.biz_des02 : ''
    }

    // 调度插件
    const schedulerConfig = {
      url: playerData.dispatch_server,
      webinar_id: type === "live" ? opt.liveOption.roomId.trim() : opt.vodOption.recordId.trim(),
      uid: playerData.log_info.uid,
      bu: 1,  // 业务类型 pass 为1
      quality: type === "live" ? [] : playerData.definition, // 要获取的清晰度列表   直播传空数组
      defaultDef: '480p', // 默认清晰度，如果没有播原画
      app_type: type === "live" ? playerData.app_type : null
    }

    let align = "";
    switch (playerData.watermark.position) {
      case 1:  // 左上角
        align = 'tl';
        break;
      case 2: // 右上角
        align = 'tr';
        break;
      case 3: // 右下角
        align = 'br';
        break;
      case 4: // 左下角
        align = 'bl';
        break;
      default:
        break;
    }

    // 水印插件
    const watermarkPaasConfig = {
      url: playerData.watermark.url,
      align: align, // 图片的对其方式， tl | tr | bl | br 分别对应：左上，右上，左下，右下
      position: ['20px', '20px'], // 对应的横纵位置，支持px,vh,vw,%
      size: ['80px', '35px'], // 水印大小，支持px,vh,vw,%
      enable: playerData.watermark.url !== "" // 是否启用水印
    }

    // 弹幕插件
    const barrageConfig = {
      enable: true,
      duration: 12, // 完成基准，基于这个时间进行下浮动,取值范围为：(Math.random() * duration / 3)>>>0
      position: 3, // 0:top,距离上10%~~50%, 1：middle,30%~70%， 2：bottom,50%~90% 3:all,距离上下各10%
      fontsize: 18,
      alpha: 0.8,
      font: 'Microsoft YaHei',
      color: '#FFF'
    }

    vhallplayer.on('ready', () => {
      if (type === "vod") {
        if (playerData.cue_point !== "") {
          axios.get(playerData.cue_point).then(res => {
            if (isLoadScript) {
              VhallMsg.emitBroadcast({ type: "cue_point", data: JSON.stringify(res.data) });    // 派发cue_point文件到文档SDK
              vhallplayer.on('timeupdate', t => {
                VhallMsg.emitBroadcast({ type: "time_update", data: t });
              });
            }
          }, () => {
            console.warn('cue_point文件请求失败');
          });
        }
      }
      success && success({ vhallplayer: new VhallInterface({ vhallplayer, isLive: type === "live", videoNode: `#${opt.videoNode}` }) });
    });

    vhallplayer.init({
      x5: true,
      type: type === "live" ? opt.liveOption.type : getType(playerData.default_server.uri) === "mp4" ? "native" : "hls", // 视频类型
      isLive: type === "live",        // 是否是直播
      id: opt.videoNode,   // dom节点
      poster: opt.poster,  // 封面图
      hlsurl: type === "live" ? null : playerData.dispatch_server + playerData.default_server.uri,
      nativeurl: type === "live" ? null : playerData.dispatch_server + playerData.default_server.uri,
      plugin_reporter: JSON.stringify(reportConfig),
      plugin_scheduler: JSON.stringify(schedulerConfig),
      plugin_watermark: opt.hasOwnProperty("watermarkOption") && Object.keys(opt.watermarkOption).length !== 0 ? JSON.stringify(opt.watermarkOption) : JSON.stringify(watermarkPaasConfig),
      plugin_barrage: JSON.stringify(barrageConfig),
      plugin_marquee: opt.hasOwnProperty("marqueeOption") && Object.keys(opt.marqueeOption).length !== 0 ? JSON.stringify(opt.marqueeOption) : '{ "enable": false }'
    });

  }

}
